import React from 'react';

const IconCheck = ({ color = 'white', height = 12, width = 16, strokeWidth = 2 }) => (
    <svg width={width} height={height} fill='none' viewBox='0 0 16 12' xmlns='http://www.w3.org/2000/svg'>
        <path d='M14.6666 1L5.49992 10.1667L1.33325 6' stroke={color} strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round' />
    </svg>
);

export default IconCheck;
